const cards = [
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20minimal%20architectural%20detail%20with%20layered%20concrete%20surfaces%20and%20soft%20natural%20light%20casting%20geometric%20shadows%2C%20warm%20beige%20and%20charcoal%20tones%2C%20no%20people%2C%20no%20text%2C%20clean%20modern%20composition%2C%20editorial%20photography%20style%20with%20subtle%20texture&width=800&height=600&seq=eng-card-01&orientation=landscape",
    label: "Architecture",
    title: "Scalable and maintainable systems designed for long-term evolution",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Near%20black%20dark%20background%20with%20a%20single%20fluorescent%20yellow%20green%20neon%20glowing%20geometric%20shape%20in%20the%20center%2C%20minimal%20abstract%20composition%2C%20high%20contrast%2C%20clean%20sharp%20lines%2C%20digital%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20no%20logos&width=800&height=600&seq=eng-card-02&orientation=landscape",
    label: "Performance",
    title: "High-performance engineering with a focus on speed and stability",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20minimal%20textured%20surface%20with%20soft%20light%20gradients%20and%20organic%20geometric%20forms%2C%20warm%20neutral%20earth%20tones%2C%20smooth%20curves%20intersecting%20with%20straight%20lines%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20contemplative%20minimalist%20design%20aesthetic&width=800&height=600&seq=eng-card-03&orientation=landscape",
    label: "Usability",
    title: "User-centered design that prioritizes clarity and intuitive interaction",
  },
];

export default function EngineeringApproach() {
  return (
    <section className="w-full bg-white py-20 md:py-28">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-16 mb-16 md:mb-20">
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <p className="text-5xl md:text-6xl font-bold text-foreground-300 font-heading leading-tight">
              How we
            </p>
            <p className="text-5xl md:text-6xl italic text-foreground-950 font-heading leading-tight">
              engineer
            </p>
          </div>
          <div className="w-full lg:w-1/2">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[520px]">
              Our approach combines clean architecture principles with performance optimization and user-centered design. Every system is built to be scalable, maintainable, and prepared for the future.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card) => (
            <div key={card.label} className="flex flex-col">
              <div className="w-full aspect-[4/3] rounded-[22px] overflow-hidden mb-5">
                <img
                  src={card.image}
                  alt={card.label}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="inline-block self-start px-3 py-1.5 rounded-full bg-accent-500/15 text-accent-800 text-xs font-bold tracking-wide uppercase mb-3">
                {card.label}
              </span>
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
                {card.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}